<div id="dropContainer" (click)="openFileDialog()" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
  <span *ngIf="isUploading" class="m-1">Uploading…</span>
  <span *ngIf="!isUploading && !videoSrc" class="m-1">Click inside or drop a video</span>
  <video *ngIf="!isUploading && videoSrc && !showAsImage" [src]="videoSrc" muted controls (click)="$event.stopPropagation()" (error)="onPreviewError()"></video>
  <img *ngIf="!isUploading && videoSrc && showAsImage" [src]="videoSrc" alt="Video preview" />
</div>
<div class="video-upload-inline-error" *ngIf="uploadError">{{ uploadError }}</div>
<input #fileInput type="file" accept=".mp4,.mov,.gif,video/mp4,video/quicktime,image/gif" style="display: none" (change)="onClickForwardFile($event)" />
